import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import vectorPunteado from '../../images/vector-punteado.svg';
import blog from '../../images/comunidad/blog.png';
import podcast from '../../images/comunidad/podcast.png';
import newsletter from '../../images/comunidad/newsletter.png';
import './Community.css';
import { useLanguage } from '../../context/LanguageContext';

const Community: React.FC = () => {
  const { t } = useLanguage();

  const communityItems = [
    {
      title: t('community.blog.title'),
      image: blog
    },
    {
      title: t('community.podcast.title'),
      image: podcast
    },
    {
      title: t('community.newsletter.title'),
      image: newsletter
    }
  ];

  return (
    <section className="section-container">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <div className="community-header">
              <Row className="align-items-center">
                <Col xs={12} md={8} lg={6}>
                  <div className="about-title-container">
                    <img src={vectorPunteado} alt="Community Icon" className="about-icon" />
                    <h1 className="section-title">{t('community.title')}</h1>
                    <p className="about-text">{t('community.subtitle')}</p>
                  </div>
                </Col>
              </Row>
            </div>
            
            <div className="community-row">
              {communityItems.map((item, index) => (
                <div key={index} className="community-col">
                  <Card className="community-card">
                    <Card.Title className="community-title nav-font">{item.title}</Card.Title>
                    <div className="community-image-container">
                      <img src={item.image} alt={item.title} className="community-image" />
                    </div>
                  </Card>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Community;
